import {EulaContextDTO} from '../openapi/shell-service-openapi';
import {PRIVACY_POLICY_VERSION} from './privacy-policy-version';


/** Darf der Nutzer ins Portal? */
export type PrivacyPolicyAccess = 'granted' | 'blocked';

/** Gibt der angezeigte Text die geltende Fassung wieder? */
export type PrivacyPolicyVersionMatch = 'matches' | 'deviates';

export interface PrivacyPolicyState {
  readonly access: PrivacyPolicyAccess;
  readonly version: PrivacyPolicyVersionMatch;
}

/**
 * Leitet aus dem Kontext zwei voneinander unabhängige Aussagen ab.
 *
 * Getrennt, weil ein Nutzer durchgelassen werden darf, während der angezeigte Text trotzdem nicht
 * die geltende Fassung ist - etwa wenn der Server die Zustimmungspflicht überspringt. Zusammen in
 * einem Zustand würde die eine Aussage die andere verdecken.
 *
 * `access` hängt allein an approved, nie am Fassungsvergleich: Der Server kennt neben der Fassung
 * ein Mindestdatum und kann deshalb trotz gleicher Fassung ablehnen; und wem er den Zutritt
 * zusichert, dem nimmt ihn ein abweichender Textstand nicht wieder weg.
 *
 * `rejectedByServer` schlägt den Vergleich, weil der geladene Kontext zur eigenen Fassung passen
 * kann, während der Server seine geltende Fassung bereits gewechselt hat.
 */
export function derivePrivacyPolicyState(
  eula: EulaContextDTO,
  rejectedByServer = false,
): PrivacyPolicyState {
  return {
    access: eula.approved ? 'granted' : 'blocked',
    version: deviates(eula, rejectedByServer) ? 'deviates' : 'matches',
  };
}

function deviates(
  eula: EulaContextDTO,
  rejectedByServer: boolean,
): boolean {
  if (rejectedByServer) {
    return true;
  }
  if (!eula.currentVersion) {
    // INFO: Ältere Backends liefern currentVersion noch nicht, obwohl das Feld im Vertrag Pflicht
    // ist. Ohne diesen Fall sperrte ein zuerst ausgerolltes Frontend das Zustimmen für alle, bis
    // das Backend nachzieht.
    return false;
  }
  return eula.currentVersion !== PRIVACY_POLICY_VERSION;
}
